// 获取全部指令文件
const files = require.context('./mudule', true, /\.js$/)
// 处理指令文件，获得指令对应的文件路径 (如 './auth.js' )
const keys = files.keys()

// 设置指令
export default function directives(app) {
  keys.forEach((path) => {
    // 处理指令名字，（即每个指令文件对应的文件名，如 './auth.js' 可以获得  'auth'）
    let name = path.replace(/(\.\/|\.js)/g, '')
    // 获取的指令逻辑
    let option = files(path).default
    //   指令逻辑存在，设置指令
    if (option) {
      app.directive(name, option)
    }
  })
}
